import Vue from 'vue';

import {
  MainStructure,
  NgDetail
} from '@/components/index';

Vue.component(MainStructure.name, MainStructure);
Vue.component(NgDetail.name, NgDetail);